import React from 'react'
import Layout from './src/components/layout'
// Logs when the client route changes
export const onRouteUpdate = ({ location, prevLocation }) => {
}
// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}